export enum FeatureFlag {
  AnalyticsPlanningAssistant = 'analytics.planningAssistant',
  AnalyticsBetaReports = 'analytics.betaReports',
  Allocations = 'allocations',
  ReplenshimentProactiveInsights = 'replenshiment.proactiveInsights',
  HomePage = 'homePage',
  InventoryProductLocations = 'inventory.productLocations',
  DataCenterUploads = 'dataCenter.uploads',
  AssortmentAllocations = 'assortmentAllocations',
  DataTableRowActions = 'dataTableRowActions',
  AnalyticsNewInventoryReportDashboard = 'analyticsNew.inventoryReportDashboard',
}
